export default "__VITE_ASSET__6c9c9371__"